/* eslint-disable max-classes-per-file */
// eslint-disable-next-line import/no-extraneous-dependencies

import {
  ChannelProductUrlResponse,
  CustomerResponse,
  ModelDetailPlate,
  Quote,
  RequestResponse,
  VehicleGroup,
  ChannelResponseList
} from "@infra/models/PlateInfo"
import { CirculationPlaceItem } from "@infra/models/CirculationPlace"
import { IRequest } from "@infra/models/IRequest"
import { CrossSell } from "@infra/models/CrossSell"

export class TransactionStatecontextBase {
  requestOk: boolean | null = null

  vehicleInfoOk: boolean | null = null

  circulationPlaceOk: boolean | null = null

  vehicleGroupOk: boolean | null = null

  customerOk: boolean | null = null

  channelOk: boolean | null = null

  quoteOk: boolean | null = null

  requestResponse: RequestResponse = new RequestResponse()

  canalResponseList?: ChannelResponseList[] | null

  consultaVehiculoResponse: ModelDetailPlate | null = null

  circulationPlaceResponseList: Array<CirculationPlaceItem> = []

  vehicleGroupResponse: VehicleGroup | null = null

  fullCustomerResponse: CustomerResponse = new CustomerResponse()

  channelProductUrlResponse: ChannelProductUrlResponse | null = null

  quoteResponse: Quote = new Quote()

  origen: string = ""

  flujo: string = ""

  derivacion?: number

  circulationPlaceResponse: string = ""

  confirmationOk?: boolean = false

  queryString?: string = ""

  renewalResponse: IRequest | null = null

  page?: string = ""

  reload?: boolean = false

  action?: string = ""

  tipoProceso?: string = ""

  planType?: string = ""

  hasRunRemarketingAE?: boolean = false

  isAutoEfectivoQuotationOK?: boolean = false

  hasDataPromotionAccepted?: boolean = false

  personalData?: boolean = false

  isPaymentRenovationSoatCompleted?: boolean = false

  isPaymentAutoEfectivoCompleted?: boolean = false

  isPaymentAutoEfectivoWithError?: boolean = false

  autoEfectivo?: boolean = false

  crossSell?: CrossSell = new CrossSell()

  localDocumentType?: string = ""

  localDocumentId?: string = ""

  localPlate?: string = ""
}
